export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/imageUtil.worker.f67edf5b.worker.js");
}
